export default __webpack_public_path__ + "static/media/C2.71a333d8.svg";